import { ConsentType, ConsentPermission } from 'app/area/user-profile/my-notifications/types';
import { configurationAccess } from 'app/area/user-profile/my-notifications/configuration-access';

export const isChannelActive = (type: ConsentType, permission: ConsentPermission): boolean => {
  const conf = {
    [ConsentType.sms]: permission.sms,
    [ConsentType.push]: permission.push && configurationAccess.push
  };

  return conf[type];
};
